<template>

  <el-row :gutter="5">
    <el-col :span="4"></el-col>
    <el-col :span="16"><h2 class="heading">All Personal Investments</h2></el-col>
    <el-col :span="4"></el-col>
  </el-row>

  <el-row :gutter="5">
    <el-col :span="17">
        <span class="label" style="padding-left:50px;">Creator</span>
        <el-select v-model="creator" style="width:140px;" placeholder="Select Requester" @change="getInvestmentList(1)" clearable>
            <el-option v-for="user in allUsers" :key="user.id" :label="user.fullname" :value="user.id">
            </el-option>
        </el-select>

        <span class="label">Status</span>
        <el-select v-model="status" style="width:140px;" placeholder="Select Status" @change="getInvestmentList(1)" clearable>
            <el-option lable="pending" value="pending"></el-option>
            <el-option lable="approved" value="approved"></el-option>
            <el-option lable="rejected" value="rejected"></el-option>
        </el-select>

        <span class="label">Submit time</span>
        <el-date-picker v-model="startDate" type="date" placeholder="Start Date" value-format="YYYY-MM-DD" style="width:140px;" @change="getInvestmentList(1)"></el-date-picker> 
           <span class="label"> to </span>
        <el-date-picker v-model="endDate" type="date" placeholder="End Date" value-format="YYYY-MM-DD" style="width:140px;" @change="getInvestmentList(1)"></el-date-picker>
    </el-col>
    <el-col :span="7">
        <el-button style="margin:0px 15px 0px 20px;" @click="$router.push('/investment/myInvestmentList')">
            <el-icon><Search/></el-icon> &nbsp; My Personal Investments</el-button>
        <el-button @click="$router.push('/broker/brokerStatementList')" type="plain">Broker Statments</el-button>
    </el-col>
  </el-row>

  <el-table :data="investmentList" height="88%" style="width:95%; margin:15px auto;" :row-class-name="tableRowClassName"
        :default-sort="{ prop: prop, order: order }" @sort-change="sortChange">
    <el-table-column prop="id" label="ID" align="center" width="60" sortable="custom" />
    <el-table-column prop="title" label="Title" width="300" sortable="custom" />
    <el-table-column prop="fullname" label="Creator" sortable="custom" />
    <el-table-column prop="createDate" label="Create Time"  align="center" width="140" sortable="custom" />
    <el-table-column prop="status" label="Status" align="center"  sortable="custom"/>
    <el-table-column prop="applyApprove" label="Need Approval" align="center" sortable="custom"/>
    <el-table-column prop="contractChecked" label="Contract Notes" align="center">
        <template #default="scope">
            <el-icon :size="20"  v-if="scope.row.contractChecked=='Yes'" title="Click to uncheck" @click="checkInvestment(scope.row.idMd5, false)" >
                <CircleCheckFilled />
            </el-icon>
            <el-icon :size="20" v-else title="Click to check" @click="checkInvestment(scope.row.idMd5, true)" >
                <CircleCheck style="color:#ccc;" />
            </el-icon>
        </template>
    </el-table-column>
    <el-table-column prop="checkedTime" label="Checked Time" align="center"  width="170" />
    <el-table-column prop="status" label="Action" align="center">
        <template #default="scope">
            <a href="" v-if="scope.row.status == 'pending' && global.hasRight('personal-investment', 'approver') && scope.row.creator != currentUser.id " 
                @click.prevent="$router.push('/investment/viewInvestment?code=' + scope.row.idMd5)" title="Approve" class="op">
                    Approve
            </a>
            <a href="" v-if="scope.row.status != 'pending' && (scope.row.remark == ''||scope.row.remark == null) && global.hasRight('personal-investment', 'approver')" 
                @click.prevent="$router.push('/investment/viewInvestment?code=' + scope.row.idMd5)" title="Add remark" class="op" style="font-weight:400;">
                    Remark
            </a>
            <el-icon :size="16" v-if="scope.row.status == 'pending' && scope.row.creator == global.currentUser.id" 
                @click="deleteInvestment(scope.row.idMd5)" title="Delete" class="op">
                    <Delete/>
            </el-icon>
            <el-icon :size="16" @click="$router.push('/investment/viewInvestment?code=' + scope.row.idMd5)" title="View details" class="op">
                <document />
            </el-icon>
        </template>
    </el-table-column>
  </el-table>
  <el-pagination background layout="prev, pager, next" :total="page.rowCount" :page-size="page.pageSize" :current-page="page.currPage"
    @current-change="getInvestmentList" style="justify-content: center;"></el-pagination>

</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Document, Search, Plus, Delete, CircleCheckFilled, CircleCheck } from '@element-plus/icons-vue'

export default {
    components: {
        Document, Search, Plus, Delete, CircleCheckFilled, CircleCheck
    },
    data() {
        return {
            orderObj : {prop: "id", order: "descending"},
            creator: null,
            investmentList: [],
            allUsers: [],
            page: {currPage: 1},
            currentUser: null,
            status: null,
            startDate: null,
            endDate: null,
            global,
        }
    },
    async mounted() {
        this.global.index = "investment";
        this.currentUser = this.global.currentUser;
        this.allUsers = await this.getAllUsers();
        this.getInvestmentList(1);
    },
    methods: {
        async checkInvestment(code, isChecked) {
            let data = {code: code, isChecked: isChecked};
            let result = await AXIOS("/investment/checkInvestment", data);
            if (result.success) {
                let investment = result.data;
                let index = this.investmentList.findIndex(e => e.idMd5 == code);
                this.investmentList[index] = investment;
            }
        },
        async getAllUsers() {
            let allUsers = null;
            let result = await AXIOS("/investment/getAllUsers");
            if (result.success) {
                allUsers = result.data;
            }
            return allUsers;
        },
        sortChange(orderObj) {
            this.orderObj = orderObj;
            this.getInvestmentList(1);
        },
        async getInvestmentList(pageNo) {
            this.page.currPage = pageNo;
            let data = {pageNo: pageNo};
            if (this.status) data["status"] = this.status;
            if (this.creator) data["creator"] = this.creator;
            if (this.startDate) data["startDate"] = this.startDate;
            if (this.endDate) data["endDate"] = this.endDate;
            if (this.$route.query && this.$route.query.action)
                data["action"] = this.$route.query.action;
            if (this.orderObj.prop) {
                data["prop"] = this.orderObj.prop;
                data["order"] = this.orderObj.order;
            }

            let result = await AXIOS("/investment/allInvestmentList", data);
            if (result.success) {
                this.investmentList = result.data.list;
                this.page = result.data.page;
            }
        },
        tableRowClassName(scope) {
            return (scope.row.status == "approved" || scope.row.status == "rejected") ? "" : scope.row.status;
        }
    }
}
</script>

<style>
</style>